import React, { useState, useEffect, useCallback } from 'react';

import { IVisas, visas } from 'data';
import { ContinueButton, SelectWithConfirm, YearInputWithConfirm } from 'shared-components';

import { Q } from '../../../../../store/student/types';
import { IStudentOtherVisa } from '../../../../../types';

interface IProps {
  index: number;
  visaType: string;
  year: string;
  onSaveAndClose: (visa: IStudentOtherVisa) => void;
}

const visasCopy: IVisas[] = JSON.parse(JSON.stringify(visas));

const OtherVisas = (props: IProps) => {
  const { index, onSaveAndClose } = props;
  const [visaType, setVisaType] = useState<string>(props.visaType);
  const [year, setYear] = useState<string>(props.year);
  const [complete, setComplete] = useState<boolean>(props.visaType !== '' && props.year !== '');

  const [yearErrorMsg, setYearErrorMsg] = useState<string>('');

  const validateYear = useCallback(() => {
    const currentYear = new Date().getFullYear();
    if (currentYear - Number(year) < 0) {
      setYearErrorMsg('Year must be in the past or current year');
    } else {
      setYearErrorMsg('');
    }
  }, [year]);

  const saveAndClose = () => {
    onSaveAndClose({
      visaType,
      year
    });
  };

  const handleOnSaveAndCloseClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    saveAndClose();
  };

  useEffect(() => {
    setComplete(visaType !== '' && year !== '' && year.length === 4 && yearErrorMsg === '');
  }, [visaType, year, yearErrorMsg]);

  useEffect(() => {
    if (year.length === 4) {
      validateYear();
    }
  }, [year, validateYear]);

  return (
    <>
      <SelectWithConfirm
        key={`${Q.PREV_UK_OTHER_VISA_TYPE}-${index}`}
        id={`${Q.PREV_UK_OTHER_VISA_TYPE}-${index}`}
        label={'What type of visa were you granted?'}
        options={visasCopy}
        value={visaType}
        onChange={(evt: React.FormEvent<HTMLInputElement>) => setVisaType(evt.currentTarget.value)}
      />

      <YearInputWithConfirm
        key={`${Q.PREV_UK_OTHER_VISA_YEAR}-${index}`}
        id={`${Q.PREV_UK_OTHER_VISA_YEAR}-${index}`}
        value={year}
        label={'What year were you granted this visa?'}
        onChange={(evt: React.FormEvent<HTMLInputElement>) => setYear(evt.currentTarget.value)}
        maxLength={4}
        errorText={yearErrorMsg}
        placeholder="YYYY"
      />

      <ContinueButton index={index} complete={complete} handleOnSaveAndCloseClick={handleOnSaveAndCloseClick} />
    </>
  );
};

export default OtherVisas;
